import { MyFirebase } from './my-firebase';
import { ApiV1 } from './api-v1';


import { Injectable } from '@angular/core';
import firebase from 'firebase';


@Injectable()
/**
 * Auth user.
 * Use custom token for authentification
 * 
 * Todo MyFirebase Zone run ?
 */
export class AuthData {

  constructor(public apiV1: ApiV1, public myFirebase: MyFirebase) {

    // 
    this.watchCurrentUser();

  }

/*

  TODO

    custom token 
    acces a users/{uid} read pour le user courant
     

*/

  private readedUser  = false;
  private onAuthStateChangedCb: { (): void; }[] = [];

  private onAuthStateChangedEvent() {
    if (!this.onAuthStateChangedCb) return;
    for(var cb of this.onAuthStateChangedCb) {
      cb();
    }
  }
  
  //
  // Register Cb when user auth change
  onAuthStateChanged( callback: () => any ) {
    
    if (this.readedUser) callback();
    this.onAuthStateChangedCb.push(callback);
  }



  // Current user 
  user : firebase.User;

  // The my save user in Fb '/users/'+user.uid 
  myFbUser ;


  private watchCurrentUser() {

    // Changement auth
    firebase.auth().onAuthStateChanged( (user) => {

      this.user = user;

      this.readedUser = false;

      // Unsubscribe, user
      if (this.myFbUser) {
        this.myFbUser.end();
        this.myFbUser = null;
      }

      // Pas de user
      if (!this.user) {
        // Call onAuthStateChangedEvent    
        this.onAuthStateChangedEvent();
        return;
      }

      //
      // User is signed in. 
console.log("User auth uid : " + user.uid);
        
      this.myFbUser = this.myFirebase.getObject(firebase.database().ref('/users/'+user.uid));
      this.myFbUser.start().then( (myUser)=>{

        // this.myFbUser = myUser;
        this.onAuthStateChangedEvent();

      });

    }); // this.onAuthStateChanged( (user) 

  }



  getUser() {
    return this.user;
  }

  getUserLevel() {
    if (!this.myFbUser) return '';
    if (!this.myFbUser.object) return '';
    return this.myFbUser.object.level;
  }

  isUserWrite() {
    return this.getUserLevel() == 'write' || this.getUserLevel() == 'admin';
  }

  isUserAdmin() {
    // console.log('isUserAdmin: ' + this.getUserLevel() );
    return this.getUserLevel() == 'admin';
  }






  /**
   * [loginUser We'll take an email and password and log the user into the firebase app]
   * @param  {string} email    [User's email address]
   * @param  {string} password [User's password]
   */
  loginUser(email: string, password: string): firebase.Promise<any> {

    // return firebase.auth().signInWithEmailAndPassword(email, password).then( (user) => { 
    //   return user;
    // }).then( () => { 
    //   return this.apiV1.signInCustomToken();
    // }).then( (custToken) => {
    //   return firebase.auth().signInWithCustomToken(custToken);
    // })
    // ;

    return this.apiV1.signInCustomToken(email, password).then( (custToken) => { 
      return firebase.auth().signInWithCustomToken(custToken);
    });    
  }

  /**
   * [signupUser description]
   * This function will take the user's email and password and create a new account on the Firebase app, once it does
   * it's going to log the user in and create a node on userProfile/uid with the user's email address, you can use
   * that node to store the profile information.
   * @param  {string} email    [User's email address]
   * @param  {string} password [User's password]
   */
  signupUser(email: string, password: string): firebase.Promise<any> {
      return firebase.auth().createUserWithEmailAndPassword(email, password).then((newUser) => {
         // firebase.database().ref('/users').child(email).set({
          //    firstName: "anonymous",
           //   id:newUser.uid,
         // });
        firebase.database().ref('/userProfile').child(newUser.uid).set({
            firstName: "anonymous",
             email: email
      });
    });
  }

  /**
   * [resetPassword description]
   * This function will take the user's email address and send a password reset link, then Firebase will handle the
   * email reset part, you won't have to do anything else.
   *
   * @param  {string} email    [User's email address]
   */
  resetPassword(email: string): firebase.Promise<any> {
    return firebase.auth().sendPasswordResetEmail(email);
  }

  /**
   * This function doesn't take any params, it just logs the current user out of the app.
   */
  logoutUser(): firebase.Promise<any> {
    return firebase.auth().signOut();
  }

}



// WEBPACK FOOTER //
// ./src/providers/auth-data.ts